<template>
  <div class="form-data-viewer">
    <div v-if="orderedSections.length > 0" class="space-y-8">
      <div v-for="(section, sectionIndex) in orderedSections" :key="section.id" class="space-y-4">
        <div class="section-title">
          <span class="text-md font-semibold text-gray-800">
            {{ sectionIndex + 1 }}. {{ section.name }}
          </span>
          <!-- <p v-if="section.description" class="text-gray-600 text-sm mt-1">{{ section.description }}</p> -->
        </div>

        <div v-if="section.fields && section.fields.length > 0" class="pl-6">
          <b-row>
            <b-col
                v-for="(fieldData) in getSortedFields(section.fields)"
                :key="fieldData.field.id"
                cols="12"
                :md="isFullWidth(fieldData.field.type) ? 12 : 6"
                class="mb-3 space-y-1"
            >
              <b-form-group
                  v-if="isTextType(fieldData.field.type)"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    :type="fieldData.field.type === 'email' ? 'email' : fieldData.field.type === 'number' ? 'number' : 'text'"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'textarea' || fieldData.field.type === 'long_text'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-textarea
                    class="form-text text-sm noFocus"
                    disabled="true"
                    rows="3"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-textarea>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'select' || fieldData.field.type === 'dropdown'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getOptionLabel(fieldData.field, getFieldValue(fieldData.field.id)) || getFieldValue(fieldData.field.id) || '—'"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'date'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'checkbox' || fieldData.field.type === 'boolean'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="formatCheckboxValue(fieldData.field.id)"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'radio'"
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="getFieldValue(fieldData.field.id) || '—'"
                    required>
                </b-form-input>
              </b-form-group>

              <b-form-group
                  v-else-if="fieldData.field.type === 'postal-address'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <PostalAddressView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'admin-units'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <AdminUnitsView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'isic'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <NatureOfBusinessISICView
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'contact'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <ContactView
                    :data="getObjFieldValue(fieldData.field.id)"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'country'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <CountryView
                    :data="getFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'individuals' || fieldData.field.type === 'associates' || fieldData.field.type === 'representatives'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <IndividualsView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'beneficial-owners'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <BeneficialOwnersView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>  
              
              <b-form-group
                  v-else-if="fieldData.field.type === 'corporates' || fieldData.field.type === 'corporate-associates' || fieldData.field.type === 'corporate_associates'"
                  class="text-sm my-1"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')">
                <CorporatesView
                    :cardinality="fieldData.field.cardinality"
                    :data="getObjFieldValue(fieldData.field.id)"
                    :api="api"
                />
              </b-form-group>

              <b-form-group
                  v-else
                  class="text-sm my-1"
                  :id="'input-group-' + fieldData.field.id"
                  :label="fieldData.field.label + (fieldData.field.isMandatory ? ' *' : '')"
                  :label-for="'input-' + fieldData.field.id">
                <b-form-input
                    class="form-text text-sm noFocus"
                    type="text"
                    disabled="true"
                    :value="formatComplexValue(getFieldValue(fieldData.field.id))"
                    required>
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <div v-else class="text-center py-12">
      <p class="text-gray-500">No application data to preview</p>
    </div>
  </div>
</template>

<script>
import PostalAddressView from './widgets/viewers/PostalAddressView.vue';
import AdminUnitsView from './widgets/viewers/AdminUnitsView.vue';
import NatureOfBusinessISICView from './widgets/viewers/NatureOfBusinessISICView.vue';
import ContactView from './widgets/viewers/ContactView.vue';
import CountryView from './widgets/viewers/CountryView.vue';
import IndividualsView from './widgets/viewers/IndividualsView.vue';
import BeneficialOwnersView from './widgets/viewers/BeneficialOwnersView.vue';
import CorporatesView from './widgets/viewers/CorporatesView.vue';

export default {
  name: 'FormDataViewer',
  components: {
    PostalAddressView,
    AdminUnitsView,
    NatureOfBusinessISICView,
    ContactView,
    CountryView,
    IndividualsView,
    BeneficialOwnersView,
    CorporatesView,
  },
  props: {
    formData: {
      type: Object,
      default: null,
    },
    valueData: {
      type: Array,
      default: () => [],
    },
    api: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formDataLocal: [],
    };
  },
  computed: {
    orderedSections() {
      if (!this.formData || !this.formData.sections) return [];
      return [...this.formData.sections].sort((a, b) => (a.position || 0) - (b.position || 0));
    },
  },
  watch: {
    valueData: {
      handler() {
        this.prefillFormData();
      },
      deep: true,
    },
  },
  mounted() {
    this.prefillFormData();
  },
  methods: {
    isTextType(type) {
      return type === 'text' || type === 'email' || type === 'number';
    },
    isFullWidth(type) {
      const complexTypes = [
        'postal-address',
        'admin-units',
        'isic',
        'contact',
        'individuals',
        'beneficial-owners',
        'corporates',
        'associates',
        'representatives',
        'corporate-associates',
        'corporate_associates'
      ];
      return complexTypes.includes(type);
    },
    prefillFormData() {
      if (!this.valueData || !Array.isArray(this.valueData)) return;
      const map = {};
      this.valueData.forEach(function (step) {
        if (step && step.data && Array.isArray(step.data)) {
          step.data.forEach(function (item) {
            if (item && item.fieldId) {
              map[item.fieldId] = { fieldId: item.fieldId, fieldName: item.fieldName, value: item.value };
            }
          });
        } else if (step && step.fieldId) {
          map[step.fieldId] = { fieldId: step.fieldId, fieldName: step.fieldName, value: step.value };
        }
      });
      this.formDataLocal = Object.keys(map).map(function (k) { return map[k]; });
    },
    getFieldValue(fieldId) {
      const entry = this.formDataLocal.find(function (item) { return item.fieldId === fieldId; });
      return entry != null ? entry.value : '';
    },
    getObjFieldValue(fieldId) {
      return this.getFieldValue(fieldId);
    },
    getSortedFields(fields) {
      if (!fields) return [];
      return [...fields].sort(function (a, b) {
        const posA = (a.field && a.field.position) != null ? a.field.position : a.position;
        const posB = (b.field && b.field.position) != null ? b.field.position : b.position;
        return (posA || 0) - (posB || 0);
      });
    },
    getSortedOptions(options) {
      if (!options || !Array.isArray(options)) return [];
      return options.filter(function (opt) { return opt.isActive !== false; }).sort(function (a, b) { return (a.position || 0) - (b.position || 0); });
    },
    getOptionLabel(field, value) {
      const opts = this.getSortedOptions(field.options || []);
      const opt = opts.find(function (o) { return o.value === value; });
      return opt ? opt.label : null;
    },
    formatCheckboxValue(fieldId) {
      const v = this.getFieldValue(fieldId);
      if (Array.isArray(v)) return v.length ? v.join(', ') : '—';
      if (v === true || v === 'true') return 'Yes';
      if (v === false || v === 'false') return 'No';
      return v != null && v !== '' ? String(v) : '—';
    },
    formatComplexValue(value) {
      if (value == null || value === '') return '—';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    },
  },
};
</script>

<style scoped>
.form-data-viewer {
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  overflow-y: auto;
  padding: 1rem 1.5rem;
}
.section-title {
  border-left: 4px solid #157EC2;
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.space-y-8 > * + * { margin-top: 2rem; }
.space-y-5 > * + * { margin-top: 1.25rem; }
.space-y-4 > * + * { margin-top: 1rem; }
.space-y-2 > * + * { margin-top: 0.5rem; }
.pl-6 { padding-left: 1.5rem; }
.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
</style>
